import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('IssueFormEmployeeController', IssueFormEmployeeController);

    function IssueFormEmployeeController(
        $scope,
        $state,
        $http,
        CompanyFactory,
        CompaniesFactory,
        CustomFieldsService,
        FormVerificationService,
        toastr,
    ) {
        var vm = this;

        init();

        function init() {
            vm.getAssets = function (_, params) {
                return $http.get(`/api/v1/assets/search/`, { params });
            };

            vm.individualClientSelected = individualClientSelected;
            vm.displayAlternativeIdInput = displayAlternativeIdInput;

            vm.clientSelected = clientSelected;
            vm.imClientSelected = imClientSelected;
            vm.iwClientSelected = iwClientSelected;
            vm.onClientChange = onClientChange;
            vm.addAsset = addAsset;
            vm.removeAsset = removeAsset;
            vm.clientHasAssets = clientHasAssets;
            vm.save = save;

            vm.customFields = null;

            // store client selected from dropdown list or set by using asset search input
            vm.client = null;

            // store list of customers of the given organization
            vm.customers = [];

            // store list of assets owned by the selected client
            vm.asets = [];

            // store assets selected from dropdown list
            vm.selectedAssets = [[null, null, null]];

            // store asset found by using search input
            vm.foundAsset = null;

            CompanyFactory.readCompany().then(function (response) {
                vm.company = response.data.organization.party_uuid;

                CompaniesFactory.readCompanies(vm.company).then(
                    function (companyResponse) {
                        vm.companySettings = companyResponse.data;

                        watchClientFieldChanges();
                        watchFoundAssetChange();
                    },
                );

                CompaniesFactory.readHousingAssociations(vm.company, {
                    page_size: 10000,
                }).then(function (housingResponse) {
                    vm.customers = housingResponse.data.results;
                });
            });
        }

        function clientSelected(): boolean {
            return vm.client;
        }

        function imClientSelected(): boolean {
            return vm.client?.som;
        }

        function iwClientSelected(): boolean {
            return vm.client && !vm.client.som;
        }

        function individualClientSelected(): boolean {
            return vm.client?.business_type.value === 'KI';
        }

        function addAsset() {
            vm.selectedAssets.push([null, null, null]);
        }

        function removeAsset(index) {
            vm.selectedAssets.splice(index, 1);
        }

        function clientHasAssets(): boolean {
            return vm.assets?.length;
        }

        function displayAlternativeIdInput(): boolean {
            return vm.companySettings?.client_number_assignable;
        }

        function save() {
            try {
                var issueData = {
                    additional_personal_data: vm.additionalPersonalData,
                    client_number: vm.clientNumber,
                    client_name: (function () {
                        if (individualClientSelected()) {
                            return vm.clientName;
                        }
                    })(),
                    description: vm.description,
                    customer: vm.client.party_uuid,
                    locations: fillLocation(),
                    custom_fields: CustomFieldsService.parseCustomFields(
                        vm.customFields,
                    ),
                };

                if (imClientSelected()) {
                    issueData['category'] = vm.category.name;
                    issueData['category_id'] = vm.category.id;
                } else {
                    issueData['issue_category'] = vm.issueCategory;
                }

                CompaniesFactory.createIssue(vm.company, issueData).then(
                    function () {
                        toastr.success('Zgłoszenie zostało zarejestrowane.');
                        $state.go('company_employee.issue_list');
                    },
                    function (error) {
                        FormVerificationService.error(error.data, vm.form);
                    },
                );
            } catch (err) {
                toastr.error('Wypełnij wszystkie pola!');
            }
        }

        function fillLocation() {
            return vm.selectedAssets.map(function (asset) {
                if (typeof asset[0] === 'string') {
                    return { short_address: asset[0] };
                }
                return {
                    asset: asset[0] && asset[0].asset_id,
                    sub_asset: (asset[1] && asset[1].asset_id) || null,
                    sub_sub_asset: (asset[2] && asset[2].asset_id) || null,
                    sub_premise:
                        (asset[1] && asset[1].sub_premise) ||
                        (asset[2] && asset[2].sub_premise) ||
                        null,
                };
            });
        }

        function onClientChange() {
            vm.selectedAssets = [[null, null, null]];
        }

        function watchClientFieldChanges() {
            $scope.$watch(
                function () {
                    return vm.client;
                },
                function () {
                    if (vm.company && clientSelected()) {
                        CompaniesFactory.getLocations({
                            page_size: 1000,
                            customer: vm.client.party_uuid,
                        }).then(function (response) {
                            vm.assets = response.data.results;
                        });
                    }
                },
            );
        }

        function watchFoundAssetChange() {
            $scope.$watch(
                function () {
                    return vm.foundAsset;
                },
                function (newVal) {
                    if (newVal) {
                        if (vm.client?.party_uuid !== newVal.customer) {
                            onClientChange();
                        }
                        vm.client = vm.customers.find(
                            (c) => c.party_uuid === newVal.customer,
                        );
                        vm.selectedAssets = [[newVal, null, null]];
                        vm.foundAsset = null;
                    }
                },
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/employee/issue_form_employee.controller.ts